import React, { useEffect, useState } from 'react'
import { Button, Col, Divider, Drawer, Input, message, Select, Row, Typography } from 'antd'
import Utils from '../../../../../utils/Utils'
import Swal from 'sweetalert2'

const { Option } = Select
const { Title } = Typography

function CorrelativoInternoDrawe(props) {
  const [correlativoInterno, setCorrelativoInterno] = useState('') // Renombramos 'name' a 'correlativoInterno'
  const [selectedFarmacia, setSelectedFarmacia] = useState('') // Estado para farmacia seleccionada
  const [Farmacias, setFarmacias] = useState([]) // Estado para farmacias obtenidas
  const [storeChainId, setStoreChainId] = useState('') // Estado para la cadena seleccionada
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState('')

  useEffect(() => {
    setCorrelativoInterno(props.edit ? props.editData.correlativoInterno : '') // Cargar valor del correlativo interno si está en edición
    setStoreChainId(props.edit ? props.editData.store_chain_id : null)
    
    if (props.visible) {
      onSearchFarmacias() // Llamar a la función para cargar las farmacias
    }
  }, [props.visible]) // Ejecutar cuando el modal o Drawer sea visible

  // Función para obtener las farmacias
  const onSearchFarmacias = async () => {
    setLoading(true)
    try {
      const response = await Utils.getStorsCagegory() // Obtener las farmacias de la API
      setLoading(false)
      setFarmacias(response.stores) // Guardar las farmacias en el estado
    } catch (err) {
      setLoading(false)
      Swal.fire({
        title: "Error al cargar los datos de las farmacias.",
        icon: "error",
        showConfirmButton: false,
        timer: 3000
      })
    }
  }

  // Función para manejar el cambio en el campo correlativo interno (solo números y hasta 10 dígitos)
  const handleCorrelativoChange = (e) => {
    const value = e.target.value
    // Solo permitir números y máximo 10 dígitos
    if (/^\d{0,10}$/.test(value)) {
      setCorrelativoInterno(value)
    }
  }

  // Función para guardar los datos
  const onSaveButton = async () => {
    
    if (!correlativoInterno || !storeChainId || !name ) {
      return message.warning('Todos los campos son obligatorios') // Validar que se haya ingresado correlativo y seleccionado la farmacia
    }

    const data = { store_id: storeChainId, initial_correlative: correlativoInterno, series: name, status_id: 4, user_id: 1, switched: false } // Objeto con los datos a guardar

    // Aquí va la lógica para guardar los datos en tu backend o API
    props.saveButton(props.edit, data, props.edit ? props.editData.id : null)


  }

  return (
    <Drawer
      placement="right"
      closable={false}
      onClose={props.closable}
      visible={props.visible}
      width={800}
    >
      <div className="products-container-combo-tabs">
        <Title>{props.edit ? 'Editar Correlativo Interno' : 'Nuevo Correlativo Interno'}</Title>
        <Divider className="divider-custom-margins-users" />
        <Row gutter={16} className={'section-space-field'}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <div className={'title-space-field'}>Serie*</div>
            <Input
            value={name}
            onChange={value => setName(value.target.value)}
            placeholder={'Nombre tipo de ubicación'}
            size={'large'}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24}>
            <div className={'title-space-field'}>Correlativo Interno*</div> {/* Cambié 'Nombre' por 'Correlativo Interno' */}
            <Input
              value={correlativoInterno}
              onChange={handleCorrelativoChange} // Usamos la función para controlar la entrada
              placeholder={'Ingrese el correlativo interno'}
              size={'large'}
              maxLength={10} // Limitar a 10 caracteres
              type="number" // Esto limita la entrada a números (aunque no bloquea todos los teclados, ayuda)
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Cadena a la que pertenece*</div>
            <Select
              showSearch
              optionFilterProp="children"
              value={storeChainId}
              className={'single-select'}
              placeholder={'Seleccionar cadena a la que pertenece'}
              size={'large'}
              style={{ width: '100%' }}
              onChange={setStoreChainId}
              loading={loading}
            >
              {/* Renderizar las farmacias en el Select */}
              {Farmacias.map(farmacia => (
                <Option key={farmacia.id} value={farmacia.id}>
                  {farmacia.name}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
      </div>
      <Divider className={'divider-custom-margins-users'} />
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className="text-right">
            <div>
              <Button type="link" className="cancel-button" onClick={() => props.cancelButton()}>
                Cancelar
              </Button>
              <Button htmlType="submit" className="title-tendero new-button" onClick={onSaveButton}>
                Guardar
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Drawer>
  )
}

export default CorrelativoInternoDrawe
